import { BaseError } from '../../errors/BaseError';

/**
 * コネクションエラー例外
 */
export class ApiConnectionError extends BaseError {
  public readonly response: any;

  constructor(response: any = {}) {
    super();
    this.response = response;
  }
}
